var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBitbucket = function SvgBitbucket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94C748",
    d: "M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#101214",
    d: "m35.685 23.527-1.972 12.048c-.129.729-.643 1.157-1.372 1.157H15.62c-.73 0-1.244-.428-1.372-1.157l-3.473-21.48c-.13-.73.257-1.201.943-1.201h24.525c.686 0 1.072.471.943 1.2l-.943 5.66c-.13.814-.6 1.157-1.372 1.157H20.12c-.214 0-.343.129-.3.386l1.158 7.118c.043.171.171.3.343.3h5.317c.171 0 .3-.129.343-.3l.814-5.146c.086-.643.515-.9 1.115-.9h5.788c.858 0 1.115.429.986 1.158"
  })));
};
export default SvgBitbucket;